module.exports = __webpack_public_path__ + "img/38.275e4618.jpg";